import { LoaderComponent } from '@/shared/components/ui';
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetPlan } from '@/shared/actions/erp';
import { SavePlan } from '../../shared/components';

export type UpdatePlanPageProps = {};

const UpdatePlanPage: React.FC<UpdatePlanPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_plan);
  const returnUrlPlansPage = ROUTER_PATHS.servicioInternet.planesNav;

  const { id } = useParams();
  const { data, isLoading } = useGetPlan(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_plan) return <Navigate to={returnUrlPlansPage} />;

  return <SavePlan titlePage="Editar Plan" editPlan={data.data} />;
};

export default UpdatePlanPage;
